/* HSX — yeni yüz davranış katmanı: reveal + sticky mobil CTA */
(function () {
  /* kaydırınca yumuşak belirme */
  var rv = document.querySelectorAll('.hsx-rv');
  if ('IntersectionObserver' in window && rv.length) {
    var io = new IntersectionObserver(function (girisler) {
      girisler.forEach(function (g) {
        if (g.isIntersecting) { g.target.classList.add('on'); io.unobserve(g.target); }
      });
    }, { threshold: 0.12 });
    rv.forEach(function (el) { io.observe(el); });
  } else {
    rv.forEach(function (el) { el.classList.add('on'); });
  }

  /* sahne (interaktif vitrin): satıra tıkla → sahnedeki görsel değişsin */
  document.querySelectorAll('.hsx-sahne').forEach(function (sec) {
    var siralar = sec.querySelectorAll('.sira');
    var kareler = sec.querySelectorAll('.stage img');
    var mikro = sec.querySelector('.stage .mikro');
    var isim = sec.querySelector('.stage .isim');
    var not = sec.querySelector('.stage .not');
    var sayac = sec.querySelector('.stage .sayac');
    if (!siralar.length || !kareler.length) return;
    function sec_(i) {
      siralar.forEach(function (s, j) { s.classList.toggle('aktif', i === j); });
      kareler.forEach(function (k, j) { k.classList.toggle('aktif', i === j); });
      var s = siralar[i];
      if (mikro) mikro.textContent = s.getAttribute('data-mikro') || '';
      if (isim) isim.textContent = s.getAttribute('data-isim') || '';
      if (not) not.textContent = s.getAttribute('data-not') || '';
      if (sayac) sayac.textContent = (i + 1) + ' / ' + siralar.length;
    }
    siralar.forEach(function (s, i) {
      s.addEventListener('click', function () { sec_(i); });
      s.addEventListener('mouseenter', function () { sec_(i); });
    });
    sec_(0);
  });

  /* sticky mobil CTA: hero geçilince görünür */
  var sticky = document.querySelector('.hsx-sticky');
  if (sticky) {
    var esik = document.querySelector('.hsx-hero') || document.body;
    var goster = function () {
      var y = window.scrollY || document.documentElement.scrollTop;
      var sinir = esik.offsetTop + esik.offsetHeight * 0.7;
      sticky.classList.toggle('gorunur', y > sinir);
    };
    window.addEventListener('scroll', goster, { passive: true });
    goster();
  }
})();
